import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function HotWalletIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M6 19.5q-1.448 0-2.474-1.026A3.37 3.37 0 0 1 2.5 16V8q0-1.448 1.026-2.474A3.37 3.37 0 0 1 6 4.5h12q1.448 0 2.474 1.026A3.37 3.37 0 0 1 21.5 8v8q0 1.448-1.026 2.474A3.37 3.37 0 0 1 18 19.5zM6 8.25h12q.57 0 1.074.164.504.163.926.496V8q0-.824-.587-1.412A1.93 1.93 0 0 0 18 6H6q-.824 0-1.412.588A1.93 1.93 0 0 0 4 8v.91q.421-.333.926-.496c.347-.11.71-.166 1.074-.164m-1.908 2.99 11.231 2.73a.92.92 0 0 0 .798-.181l3.6-3.025a1.94 1.94 0 0 0-.705-.733A1.9 1.9 0 0 0 18 9.75H6a1.914 1.914 0 0 0-1.908 1.49" />
    </Icon>
  );
}

HotWalletIcon.displayName = 'HotWalletIcon';
